/**
 * 첨부파일(PDF) 선택 상태 Context
 * 모달에서 PDF 선택 시 BookViewer 패널로 전달
 */

import React, { createContext, useContext, useState, useCallback } from 'react';
import { Attachment } from '../services/attachmentService';

interface AttachmentContextValue {
  pdfToOpenFromModal: Attachment | null;
  setPdfToOpenFromModal: (attachment: Attachment | null) => void;
  openPdfFromModal: (attachment: Attachment) => void;
}

const AttachmentContext = createContext<AttachmentContextValue | null>(null);

export const AttachmentProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [pdfToOpenFromModal, setPdfToOpenFromModal] = useState<Attachment | null>(null);

  const openPdfFromModal = useCallback((attachment: Attachment) => {
    setPdfToOpenFromModal(attachment);
  }, []);

  const value: AttachmentContextValue = {
    pdfToOpenFromModal,
    setPdfToOpenFromModal,
    openPdfFromModal,
  };

  return (
    <AttachmentContext.Provider value={value}>
      {children}
    </AttachmentContext.Provider>
  );
};

export const useAttachmentContext = (): AttachmentContextValue | null => {
  return useContext(AttachmentContext);
};
